import React from 'react';
import { Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-8 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-lg font-semibold mb-1">{t('hero.title')}</p>
            <p className="text-slate-400 text-sm">{t('footer.tagline')}</p>
          </div>

          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <span>© {currentYear} {t('footer.rights')}</span>
            <span>•</span>
            <span className="flex items-center gap-1">
              {t('footer.madeWith')} <Heart size={14} className="text-red-500" fill="currentColor" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
